// Libraries
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const TextAreaContainer = styled.div`
    border-radius: 2px;
    display: inline-block;
    position: relative;
    vertical-align: middle;
    width: 100%;
`;

const TextAreaElement = styled.textarea`
    appearance: none;
    background-color: white;
    border: 1px solid #d8d8d8;
    border-radius: 4px;
    color: #000;
    display: inline-block;
    font-family: 'lato-regular';
    font-size: 13px;
    height: 77px;
    outline: 0;
    overflow: auto;
    padding: 10px 13px;
    resize: none;
    vertical-align: middle;
    width: 100%;
    z-index: 1;
`;

const StyledErrorWrapper = styled.span`
    color: #f00;
    display: inline-block;
    font-size: 12px;
    margin: 8px 0;
`;

const TextArea = props => {
    const {
        value,
        input,
        wrapperClass,
        autoFocus,
        maxlength,
        name,
        placeholder,
        cols = '30',
        rows = '5',
        wrap = 'hard',
        readonly,
        hideErrors,
        meta,
        disabled = false,
        handleChange,
        isRequired,
        showOnlyReduxValue
    } = props;

    function handleSelectChange(event) {
        if (event && input) {
            input.onChange(event.target.value);
        } else if (handleChange) {
            handleChange(event.target.value);
        }
    }

    return (
        <TextAreaContainer className={`textarea-wrap ${wrapperClass || ''}`}>
            <TextAreaElement
                onChange={event => handleSelectChange(event)}
                value={showOnlyReduxValue ? (input && input.value) :  ((input && input.value) || value) }
                autoFocus={autoFocus}
                cols={cols}
                maxLength={maxlength}
                name={name}
                placeholder={placeholder}
                rows={rows}
                wrap={wrap}
                readonly={readonly}
                disabled={disabled}
                required={isRequired}
            />
            {!hideErrors && meta && meta.touched && meta.error && (
                <StyledErrorWrapper className="error-message">
                    {meta.error}
                </StyledErrorWrapper>
            )}
        </TextAreaContainer>
    );
};

TextArea.propTypes = {
    wrapperClass: PropTypes.string,
    handleChange: PropTypes.func,
    hideErrors: PropTypes.bool,
    input: PropTypes.object,
    meta: PropTypes.object,
    cols: PropTypes.number,
    maxlength: PropTypes.number,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    rows: PropTypes.number,
    wrap: PropTypes.string,
    readonly: PropTypes.bool,
    disabled: PropTypes.bool,
    autoFocus: PropTypes.bool,
    isRequired: PropTypes.bool,
};

export default TextArea;
